<template>
  <div class="main-content">
    <breadcrumb :nameSection="nameSection" :listRoutes="listRoutes"></breadcrumb>

    <div class="form-content">
      <div class="form-content-title">
        <div class="form-content-title-block form-title">
          <div class="form-title-block form-title-principal">
            <span>Categorias</span>
          </div>

          <div
            class="form-title-block"
            v-if="$store.state.user.attributes.permissions_keys.includes(8)"
          >
            <button class="btn btn-primary" @click="openModal('nueva-categoria')">
              <i class="fas fa-plus"></i>
              Nueva Categoria
            </button>
          </div>
        </div>
      </div>
      <div class="row px-3 mb-4">
        <form class="d-flex col-8 px-0" @submit.prevent="handleSubmit" >
          <input v-model="keyword" class="form-control col-10" type="search" placeholder="Buscar categoria">
          <button class="btn btn-danger col-1" type="button"  @click="handleClear">X</button>
          <button class="btn btn-success col-2" type="submit">Buscar</button>
        </form>
        <div class="offset-2"></div>
        <button class="btn btn-primary col-2" @click="exportToExcel">Exportar a Excel</button>
      </div>
      <div class="table-paquete">
        <data-table
          :columns="columns"
          :sortKey="sortKey"
          :sortOrders="sortOrders"
          @sort="sortBy"
          v-if="is_loading == false"
        >
          <section class="u-table p-4">
            <div class="u-row-cat u-row--header">
              <h4 class="u-row__title">ID</h4>
              <h4 class="u-row__title">Key</h4>
              <h4 class="u-row__title">Nombre de Categoria</h4>
              <h4 class="u-row__title">Margen de ganancia</h4>
              <h4 class="u-row__title">Subpartida</h4>
              <h4 class="u-row__title">Path</h4>
                <h4 class="u-row__title">Acciones</h4>
            </div>
            <div class="u-row-cat" v-for="data in listCategory" :key="data">
              <p class="cat-content">{{ data.id }}</p>
              <p class="cat-content">{{ data.key }}</p>
              <p class="cat-content">{{ data.name }}</p>
              <p class="cat-content">{{ data.margin }}</p>
              <p class="cat-content">{{ data.subpartida }}</p>
              <p class="cat-content">{{ data.path }}</p>
              <div class="cat-content">
                <button
                  class="btn btn-success"
                  @click="openModal('editar-categoria', data)"
                >
                  Editar
                </button>
                <button class="btn btn-danger" @click.prevent="deleteCategory(data.id)">
                  Eliminar
                </button>
              </div>
            </div>
          </section>
        </data-table>
      </div>
    </div>

    <pagination
      :pagination="pagination"
      @changePagination="getCategoriasWithFilter"
      v-if="is_loading == false"
    ></pagination>

    <dialog id="nueva-categoria">
      <article class="u-modal">
        <form @submit.prevent="createCategory" class="u-modal-content">
          <div class="form-block-text d-flex justify-content-between">
            <span>Nueva categoria</span>
            <span style="cursor: pointer" @click="closeModal('nueva-categoria')">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                style="fill: rgba(0, 0, 0, 1); transform: ; msfilter: "
              >
                <path
                  d="m16.192 6.344-4.243 4.242-4.242-4.242-1.414 1.414L10.535 12l-4.242 4.242 1.414 1.414 4.242-4.242 4.243 4.242 1.414-1.414L13.364 12l4.242-4.242z"
                ></path>
              </svg>
            </span>
          </div>

          <div class="form-group">
            <label>Key</label>
            <div class="input-group">
              <input
                type="text"
                v-model="formCreate.key"
                name=""
                class="form-control input"
                required
              />
            </div>
          </div>
          <div class="form-group">
            <label>Nombre de categoria</label>
            <div class="input-group">
              <input
                type="text"
                v-model="formCreate.name"
                name=""
                class="form-control input"
                required
              />
            </div>
          </div>
          <div class="form-group">
            <label>Margen de ganancia</label>
            <div class="input-group">
              <input
                type="number"
                v-model="formCreate.margin"
                name=""
                class="form-control input"
                required
              />
            </div>
          </div>
          <div class="form-group">
            <label class="mb-3">Subpartida</label>
            <select
              name=""
              id=""
              class="form-control"
              v-model="formCreate.subpartida"
              required
            >
              <option :value="data.id" v-for="data in subPartidaList" :key="data">
                {{ data.id }}
              </option>
            </select>
          </div>
          <button type="submit" class="btn btn-primary mx-auto d-block mt-4">
            Registrar categoria
          </button>
        </form>
      </article>
    </dialog>
    <dialog id="editar-categoria">
      <article class="u-modal">
        <form @submit.prevent="updateCategory" class="u-modal-content">
          <div class="form-block-text d-flex justify-content-between">
            <span>Editar categoria</span>
            <span style="cursor: pointer" @click="closeModal('editar-categoria')">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                style="fill: rgba(0, 0, 0, 1); transform: ; msfilter: "
              >
                <path
                  d="m16.192 6.344-4.243 4.242-4.242-4.242-1.414 1.414L10.535 12l-4.242 4.242 1.414 1.414 4.242-4.242 4.243 4.242 1.414-1.414L13.364 12l4.242-4.242z"
                ></path>
              </svg>
            </span>
          </div>
          <div class="form-group">
            <label>Key</label>
            <div class="input-group">
              <input
                type="text"
                v-model="formCreate.key"
                name=""
                class="form-control input"
                required
              />
            </div>
          </div>
          <div class="form-group">
            <label>Nombre de categoria</label>
            <div class="input-group">
              <input
                type="text"
                v-model="formCreate.name"
                name=""
                class="form-control input"
                required
              />
            </div>
          </div>
          <div class="form-group">
            <label>Margen de ganancia</label>
            <div class="input-group">
              <input
                type="number"
                v-model="formCreate.margin"
                name=""
                step="any"
                class="form-control input"
                required
              />
            </div>
          </div>
          <div class="form-group">
            <label class="mb-3">Subpartida</label>
            <select
              name=""
              id=""
              class="form-control"
              v-model="formCreate.subpartida"
              required
            >
              <option :value="data.id" v-for="data in subPartidaList" :key="data">
                {{ data.id }}
              </option>
            </select>
          </div>
          <button type="submit" class="btn btn-primary mx-auto d-block mt-4">
            Editar categoria
          </button>
        </form>
      </article>
    </dialog>
    <dialog id="confirm-delete">
      <article class="u-modal">
        <form @submit.prevent="" class="u-modal-content">
          <div class="form-block-text d-flex justify-content-end">
            <span style="cursor: pointer" @click="closeModal('confirm-delete')">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                style="fill: rgba(0, 0, 0, 1); transform: ; msfilter: "
              >
                <path
                  d="m16.192 6.344-4.243 4.242-4.242-4.242-1.414 1.414L10.535 12l-4.242 4.242 1.414 1.414 4.242-4.242 4.243 4.242 1.414-1.414L13.364 12l4.242-4.242z"
                ></path>
              </svg>
            </span>
          </div>
          <h5 class="px-4 mt-3 mb-4">¿Seguro que desas eliminar esta categoria?</h5>
          <div class="row justify-content-center">
            <button class="btn btn-danger mr-1" @click="closeModal('confirm-delete')">
              Eliminar
            </button>
            <button class="btn btn-info ml-1" @click="closeModal('confirm-delete')">
              Cancelar
            </button>
          </div>
        </form>
      </article>
    </dialog>
  </div>
</template>
<style>
.table tr {
  border: none;
}
.u-table {
}

.u-row-cat {
  display: grid;
  align-items: start;
  grid-template-columns: repeat(7, 1fr);
  gap: 1.5rem;
  margin-bottom: 2.5rem;
}

.u-row--header {
  padding-bottom: 0.75rem;
  border-bottom: 1px solid #ccc;
}

.u-row__title {
  font-size: 14px;
  font-weight: 700;
  opacity: 0.65;
}

.cat-content {
  margin: 0;
  font-weight: 500;
}
</style>
<script>
import breadcrumb from "@/components/prefab/structures/breadcrumb.vue";
import DataTable from "./DataTable.vue";
import Pagination from "./Pagination.vue";
import axios from "axios";
export default {
  components: { DataTable, Pagination, breadcrumb },
  data() {
    // eslint-disable-next-line no-unused-vars
    let statusGroupArray = {
      1: "Todos",
      10: "Inicializando",
      20: "En proceso",
      30: "Cancelado",
      40: "Finalizado",
    };
    // eslint-disable-next-line no-unused-vars
    let statusArray = {
      1: "En evaluación",
      2: "Esperando confirmación de evaluación",
      3: "Completando información adicional",
      4: "En camino a origen",
      5: "En origen y evaluación de recepción",
      6: "Listo para embarcar",
      7: "En embarque",
      8: "Entregado correctamente",
      9: "",
      10: "Cancelado",
    };
    // eslint-disable-next-line no-unused-vars
    let cancelledReasonFlagArray = {
      1: "Por decisión propia",
      2: "Por incidencia de tracking",
    };
    let sortOrders = {};
    let columns = [
      { label: "Producto", name: "product", visible: false },
      { label: "Consignatario", name: "consignatario", visible: false },
      { label: "Acciones", name: "acciones", visible: false },
    ];

    columns.forEach((column) => {
      sortOrders[column.name] = -1;
    });
    return {
      isOrder: true,
      isWr: true,
      //almacena todos los paquetes
      warehouseorder: null,
      //Formulario para crear un paquete
      formCreate: {
        id: null,
        key: null,
        name: null,
        margin: null,
        subpartida: null,
      },
      valorRadioButton: true,
      purchaseOrders: null,
      columns,
      statusGroupArray,
      statusArray,
      cancelledReasonFlagArray,
      sortKey: "promised_delivery_date",
      sortOrders: sortOrders,
      filterKey: "",
      expanded: false,
      tableData: {
        statusFlag: {
          todos: true,
          activos: true,
          cancelados: true,
        }, // 0: Inicializando, 1: En proceso, 2: Cancelado, 3: Finalizado
        draw: 0,
        length: 10,
        status: "",
        orderBy: "promised_delivery_date",
        dir: "desc",
        filterBy: "all",
        page: 1,
        filterValue: null, // no hay ningun valor por el cual filtrar
        order_type: 5, // órdenes de Grabr y no Grabr
        store: "all",
      },
      pagination: {
        lastPage: "",
        currentPage: "",
        total: "",
        lastPageUrl: "",
        nextPageUrl: "",
        prevPageUrl: "",
        from: "",
        to: "",
      },
      grabr: {
        id: "1",
      },
      is_loading: true,
      nameSection: "Categorias",
      listRoutes: [{ nameRoute: "Categorias", titleRoute: "Categorias" }],
      subPartidaList: [],
      listCategory: [],
      listTotalCategory: [],
      keyword: "",
    };
  },
  mounted() {
    this.getCategorias();
    this.getSubPartidas();
  },
  methods: {
    deleteCategory(id) {
      var answer = window.confirm("Seguro de eliminar la Categoría:" + id);
      if (answer) {
        this.is_loading = true;

        let url = process.env.API_URL + "/api/category/deleteCategories/" + id;
        axios
          .delete(url)
          .then(() => {
            location.reload();
          })
          .catch(() => {
            alert("Error al eliminar la Categoría");
            this.is_loading = false;
          });
      }
    },
    //dev marco ->create paquete//
    createCategory() {
      this.is_loading = true;

      let url = process.env.API_URL + "/api/category/createCategories";
      axios
        .post(url, this.formCreate)
        .then(() => {
          location.reload();
        })
        .catch(() => {
          alert("Error al crear la categoría");
          this.is_loading = false;
        });
    },
    updateCategory() {
      this.is_loading = true;

      let url = process.env.API_URL + "/api/category/createCategories";
      axios
        .post(url, this.formCreate)
        .then(() => {
          location.reload();
        })
        .catch(() => {
          alert("Error al actualizar la categoría");
          this.is_loading = false;
        });
    },
    getSubPartidas() {
      let url = process.env.API_URL + "/api/subpartida/getSubpartidas";
      // eslint-disable-next-line no-unreachable
      axios
        .get(url)
        .then((response) => {
          this.subPartidaList = response.data.body.data;
        })
        .catch(() => {
          alert("No se obtuvieron SubPartida");

          return;
        });
    },
    getCategorias(page) {
      this.is_loading = true;
      //   this.tableData.draw++;
      this.tableData.page = page;
      let url = process.env.API_URL + "/api/category/getCategories";
      // eslint-disable-next-line no-unreachable
      axios
        .get(url, { params: this.tableData })
        .then((response) => {
          this.listCategory = response.data.body.data;
          this.is_loading = false;
          this.configPagination(response.data.body);
        })
        .catch(() => {
          alert("No se obtuvieron Categorias");
          this.is_loading = false;
          return;
        });
    },
    getCategoriasWithFilter(page) {
      this.is_loading = true;
      this.tableData.page = page;
      let url = process.env.API_URL + "/api/category/getCategories";
      const params = {
        length: this.tableData.length,
        page: this.tableData.page,
        filter: this.keyword.trim()
      }
      axios
        .get(url, { 
          params: params
        })
        .then((response) => {
          this.listCategory = response.data.body.data;
          this.is_loading = false;
          this.configPagination(response.data.body);
        })
        .catch(() => {
          alert("No se obtuvieron Categorias");
          this.is_loading = false;
          return;
        });
    },
    cambiarEstado() {
      this.valorRadioButton = false;
    },

    toGrabrDetail(code) {
      console.log("hacia el detalle de grabr");
      let linkToGrabr = "https://grabr.io/es/grabs/" + code;
      window.location = linkToGrabr;
    },
    showCheckboxes() {
      var checkboxes = document.getElementById("checkboxes");
      if (!this.expanded) {
        checkboxes.style.display = "block";
        this.expanded = true;
      } else {
        checkboxes.style.display = "none";
        this.expanded = false;
      }
      window.addEventListener("click", function (e) {
        if (document.getElementById("checkboxes2").contains(e.target)) {
          checkboxes.style.display = "block";
        } else {
          checkboxes.style.display = "none";
        }
      });
    },

    configPagination(data) {
      this.pagination.lastPage = data.last_page;
      this.pagination.currentPage = data.current_page;
      this.pagination.total = data.total;
      this.pagination.lastPageUrl = data.last;
      this.pagination.nextPageUrl = data.next;
      this.pagination.prevPageUrl = data.prev;
      this.pagination.from = data.from;
      this.pagination.to = data.to;
      this.pagination.perPage = this.tableData.length;
    },
    sortBy(key) {
      console.log("entro al sort", key);
      this.sortKey = key;
      this.sortOrders[key] = this.sortOrders[key] * -1;
      this.tableData.orderBy = this.sortKey;
      /* this.tableData.orderBy = this.getIndex(this.columns, 'name', key) */
      console.log(
        "tableData.orderBy",
        this.tableData.orderBy,
        "tableData.dir",
        this.tableData.dir,
        this.sortOrders[key]
      );
      this.tableData.dir = this.sortOrders[key] === 1 ? "asc" : "desc";
      console.log(
        "tableData.orderBy",
        this.tableData.orderBy,
        "tableData.dir",
        this.tableData.dir
      );
      this.getPurchaseOrders();
      console.log("paso la peticion api");
    },
    getIndex(array, key, value) {
      return array.findIndex((i) => i[key] === value);
    },
    hideModal() {
      this.$refs.formmodal.hide();
    },

    openModal(id, data) {
      if (data) {
        this.formCreate.id = data.id;
        this.formCreate.key = data.key;
        this.formCreate.name = data.name;
        this.formCreate.margin = data.margin;
        this.formCreate.subpartida = data.subpartida;
      }
      const modal = document.getElementById(id);
      modal.showModal();
    },
    closeModal(id) {
      this.formCreate.id = null;
      this.formCreate.key = null;
      this.formCreate.name = null;
      this.formCreate.margin = null;
      this.formCreate.subpartida = null;
      const modal = document.getElementById(id);
      modal.close();
    },
    prevSlide() {
      this.currentSlide === 1
        ? (this.currentSlide = this.maxSlide)
        : (this.currentSlide = this.currentSlide - 1);
    },
    nextSlide() {
      this.currentSlide === this.maxSlide
        ? (this.currentSlide = 1)
        : (this.currentSlide = this.currentSlide + 1);
    },
    handleSubmit() {
      this.getCategoriasWithFilter()
    },
    handleClear() {
      this.keyword = ""
      this.getCategorias()
    },
    exportToExcel() {
      let url = process.env.API_URL + "/api/category/getCategories";
      // const params = {
      //   length: this.tableData.length,
      //   page: this.tableData.page,
      //   filter: this.keyword.trim()
      // }
      axios
        .get(url, { 
          params: {
            export: true,
          }
        })
        .then((response) => {
          const excel_base64 = response.data.body.excel_base64
          this.convertToExcel(excel_base64)
        })
        .catch(() => {
          alert("No se pudo exportar");
          this.is_loading = false;
          return;
        });
    },
    convertToExcel(data) {
      // Cadena base64 recibida desde el backend
      var base64Data = data; // Coloca aquí la cadena base64 recibida

      // Decodificar la cadena base64 a un ArrayBuffer
      var binaryData = atob(base64Data);
      var length = binaryData.length;
      var byteArray = new Uint8Array(length);
      for (var i = 0; i < length; i++) {
          byteArray[i] = binaryData.charCodeAt(i);
      }

      // Crear un Blob a partir de los bytes decodificados
      var blob = new Blob([byteArray], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });

      // Crear una URL para el Blob
      var blobUrl = URL.createObjectURL(blob);
      window.open(blobUrl, "_blank");
    }
  },
  computed: {
    filterColumns() {
      // let activeFilterColumns = [
      //   "product_info",
      //   "destination",
      //   "order_code",
      //   "tracking_number",
      //   "grabr_code",
      //   "client_name",
      //   "client_dni",
      //   "client_grabr_id",
      //   "id",
      // ];

      let activeFilterColumns = [
        "product_info",
        "referent link",
        "order_code",
        "client_grabr_id",
        "destination",
        "tracking_number",
      ];
      return this.columns.filter((i) => activeFilterColumns.indexOf(i.name) > -1);
    },
    statusComputed() {
      console.log("statuscomputed");
      return JSON.stringify([
        this.tableData.statusFlag.todos,
        this.tableData.statusFlag.activos,
        this.tableData.statusFlag.cancelados,
      ]);
    },
  },
};
</script>



// WEBPACK FOOTER //
// CategorysTable.vue?404e401f